import {SpinnerPanel} from './spinner-panel'

import type {JSX} from 'react'

export function StartingAppIndicator(): JSX.Element {
    return <SpinnerPanel title="Initialising" />
}
